import { render, staticRenderFns } from "./UserSmallCard.vue?vue&type=template&id=1830fca4"
import script from "./UserSmallCard.vue?vue&type=script&lang=js"
export * from "./UserSmallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports